import { render, staticRenderFns } from "./junjiashenheNew.vue?vue&type=template&id=ddac10d8&scoped=true"
import script from "./junjiashenheNew.vue?vue&type=script&lang=js"
export * from "./junjiashenheNew.vue?vue&type=script&lang=js"
import style0 from "./junjiashenheNew.vue?vue&type=style&index=0&id=ddac10d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac10d8",
  null
  
)

export default component.exports